<template>
  <section class="portfolio">
    <!-- 헤더 배경 -->
    <!-- <div class="portfolio-header">
      <h1>Training</h1>
    </div> -->

    <div class="portfolio-content">
      <div class="portfolio-main">
        <h2>
          교육 및 워크숍
        </h2>
        <!-- <div class="header-underline"></div> -->
        <p>
          한국내부통제협회(ICI KOREA)는 지속적인 학습과 전문성 개발이 강건한 내부통제 시스템과 조직의
          지속가능성 확보에 핵심적이라고 믿습니다. ICI KOREA의 교육 프로그램과 워크숍은 오늘날의
          복잡한 거버넌스 환경에 맞춰 실무적 역량, 최신 내부통제 지식, 그리고 인증까지 제공하는 실무 중심의 과정입니다. </p>
        <div>
          <div>
            <div class="feature-list-title">프로그램 주요 특징</div>
            <ul class="feat-media">
              <li>
                <i class="fa-solid fa-chalkboard-user"></i>
                <div>
                  <strong>전문가 주도 강의</strong>
                  <p>내부통제, 감사, 준법, 리스크 분야의 현장 경험이 풍부한 업계 전문가가 직접 교육을 진행합니다.</p>
                </div>
              </li>
              <li>
                <i class="fa-solid fa-screwdriver-wrench"></i>
                <div>
                  <strong>실무 적용 중심 학습</strong>
                  <p>사례 기반의 실습을 통해 즉시 적용 가능한 내부통제 프레임워크를 습득합니다.</p>
                </div>
              </li>
              <li>
                <i class="fa-solid fa-layer-group"></i>
                <div>
                  <strong>맞춤형 커리큘럼</strong>
                  <p>직무와 수준에 맞춰 구성되며, 컴플라이언스·규제, 리스크 평가, 지배구조 모범사례 등을 포함합니다.</p>
                </div>
              </li>
              <li>
                <i class="fa-solid fa-people-arrows"></i>
                <div>
                  <strong>전문가 네트워킹</strong>
                  <p>다양한 분야의 전문가들과 교류하며 협업 기회를 창출할 수 있습니다.</p>
                </div>
              </li>
              <li>
                <i class="fa-solid fa-certificate"></i>
                <div>
                  <strong>공식 수료 인증서 발급</strong>
                  <p>모든 수료자는 공식 인증서를 발급받아 전문성에 대한 헌신을 입증할 수 있습니다.</p>
                </div>
              </li>
            </ul>
          </div>

        </div>

      </div>

      <!-- 사이드 배너 -->
      <aside class="portfolio-banner">
        <img class="banner-img" src="../../../assets/HeaderICIK.png" alt="ICIK 로고" />
        <p class="banner-text">
          내부통제 평가 강화와 전담조직 확대에 따라<br /> 실무형 내부통제 전문가의 중요성이 커지고<br /> 있는 요즘, CICS는 국제 기준에 맞춰 제도화된 통제장치가 올바르게 실행되도록 하는
          실질적인 내부통제 역량을 검증하는 국내 유일의 <br /> 국제공인자격입니다.
        </p>
      </aside>

    </div>
  </section>

  <!-- ✅ 교육 리스트 (표 형태) -->
  <!-- <section class="program-table" aria-label="교육 목록">

    <div class="program-table__inner">

      <h2 class="program-table__title">교육일정</h2>
      <div class="program-table__more">
        <button class="btn-more" @click="go('/traininglsit')">더보기</button>
      </div>
      <div class="program-table__head">
        <div class="th th--no">번호</div>
        <div class="th th--title">교육명</div>
        <div class="th th--period">교육일정</div>
        <div class="th th--deadline">접수마감일</div>
        <div class="th th--count">조회수</div>
        <div class="th th--status">접수상태</div>
      </div>

      <ul class="program-table__body">

        <li class="program-row" v-for="(vo, index) in eduList" :key="vo.eduId || index">
          <div class="td td--no">{{ vo.no }}</div>
          <div class="td td--title">
            <div class="title__link ellipsis" @click="goToDetail(vo.eduId)">
              {{ vo.title.length > 30 ? vo.title.slice(0, 30) + '…' : vo.title }}
            </div>
          </div>
          <div class="td td--period">{{ vo.eduStartAt?.slice(0, 10) }} ~ {{ vo.eduEndAt?.slice(0, 10) }}</div>
          <div class="td td--deadline">{{ vo.endAt }}</div>
          <div class="td td--count">{{ vo.viewCount }}</div>
          <div class="td td--status">
            <button class="status-badge is-open" v-if="vo.status == 'PUBLISHED'" >접수중</button>
            <button v-else  class="status-badge is-closed">접수 마감</button>
          </div>
        </li>
      </ul>
    </div>
  </section> -->

</template>

<script setup>
import { useRouter } from 'vue-router';
import { ref, computed, onMounted, onUnmounted, watch } from 'vue'
import { useStore } from 'vuex';
import userJson from '@/models/gridInfo/user.json'
import Pagination from '@/components/grid/pagination.vue';

const store = useStore()
const router = useRouter()
const status = ref('all')

const searchText = ref('')
const searchCode = ref('all')
const searchParam = computed(() => {
  return store.state.temp.searchParam
})


const pagingBean = computed(() => {
  return store.state.grid.pagination
})

const eduList = computed(() => store.state.grid.eduData)


const getGridData = async () => {
  const param = {
    pageNo: 1,                 
    countPerRecord: 5,
    search: searchText.value,
    typeCd: searchCode.value,
    status: 'PUBLISHED'
  }
  await store.dispatch('grid/eduList', param)
}


onMounted(async () => {
  await getGridData()
})

function go(to) {
  router.push(to)
}

const goToDetail = (code) => {
  router.push({
    name: 'trainingdetail',
    query: {
      eduId: code //
    }
  })
}

onUnmounted(() => {
	store.commit('temp/clearSearchParam')
	// 페이지 닫힐 때 해당 리스너 삭제
	
}) 
</script>

<style scoped>
/* =========================================================
   Base: 폰트/타이포 & 유틸
   - 상업적 무료: Noto Sans KR
   - 타이틀: 1.625rem / 700
   - 본문 p: 0.95rem
========================================================= */
:root{
  --accent: #30308a;   /* 포인트 */
  --text: #0f172a;     /* 본문 텍스트 */
  --muted:#334155;     /* 설명 텍스트 */
  --border:#e5e5e5;    /* 기본 보더 */
  --card-shadow: 0 6px 18px rgba(0, 27, 59, .05);
}

html, body{
  font-family: 'Noto Sans KR', sans-serif;
  color: var(--text);
  background:#fff;
}

h1, h2, .title{
  font-size: 1.625rem;
  font-weight: 700;
  letter-spacing: -.2px;
}

p{ font-size: 0.95rem; line-height: 1.8; }

/* 접근성 숨김 */
.sr-only{
  position:absolute !important;
  width:1px; height:1px; padding:0; margin:-1px;
  overflow:hidden; clip:rect(0,0,0,0); border:0;
}

/* 긴 텍스트 말줄임 */
.ellipsis{
  display:inline-block;
  max-width:100%;
  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
}

/* 공통 언더라인 (중복 정의 정리) */
.header-underline{
  width:100px; height:4px; border-radius:2px;
  background: var(--accent);
  margin: 0 0 20px 0;
}

/* =========================================================
   Portfolio
========================================================= */
.portfolio{
  max-width:1200px;
  margin:0 auto;
  background:#fff;
  display:flex;
  flex-direction:column;
}

/* Hero */
.portfolio-header{
  position:relative;
  width:100%;
  min-height:228px;
  display:flex;
  align-items:center;
  justify-content:center;
}
.portfolio-header::before{
  content:"";
  position:absolute; inset:0;
  background:#000; opacity:.5; z-index:1;
}
.portfolio-header h1{
  position:relative; z-index:2; color:#fff;
  line-height:1.3; margin:0; text-align:center;
}

/* 본문 레이아웃: Grid로 정리 (좌: 본문, 우: 배너) */
.portfolio-content{
  display:grid;
  grid-template-columns: 1fr 300px;
  gap:32px;
  align-items:start;
  padding:40px 0 0;
  background:#fff;
}
.portfolio-main{
  max-width:750px;
  display:flex; flex-direction:column;
}
.portfolio-main h2{ margin-bottom:16px; }
.portfolio-main p,
.portfolio-main li{
  color:#454f5e;
}

/* 사이드 배너 */
.portfolio-banner{
  width:100%;
  max-width:300px;
  background:#fff;
  color:var(--text);
  border:2px solid var(--accent);
  border-radius:12px;
  padding:40px 28px 32px;
  display:flex; flex-direction:column; align-items:center;
  text-align:center; gap:28px;
  box-shadow: 0 6px 18px rgba(48, 48, 138, 0.08);
}
.banner-img{ width:200px; height:auto; display:block; }
.banner-text{ line-height:1.8; color:var(--muted); }
.bold{ font-weight:700; }

/* =========================================================
   Program Table (표 형태 레이아웃)
========================================================= */
.program-table{
  padding:30px 0 60px;
}
.program-table__inner{
  max-width:1200px; margin:0 auto; padding:0 12px;
}
.program-table__title{ color:#001b3b; }

/* 헤더 & 로우 공통 그리드 설정 */
.program-table__head,
.program-row{
  display:grid;
  grid-template-columns: 60px 1fr 250px 150px 120px 140px;
  gap:12px;
  align-items:center;
  text-align:center;
}

.program-table__head{
  padding:14px 16px;
  border:1px solid var(--border);
  border-bottom:0;
  background:#fff;
  font-weight:700; color:var(--text);
}
.th{ font-size:15px; }

.program-table__body{
  border:1px solid var(--border);
  border-top:0; background:#fff;
}
.program-row{
  padding:16px; cursor:pointer;
  border-top:1px solid #f1f5f9;
}
.program-row:first-child{ border-top:0; }
.program-row:hover{ background:#fafafa; }

/* 셀 */
.td{ font-size:15px; color:#111827; }
.td--no{ color:#374151; }
.td--title{
  display:flex; align-items:center; gap:8px; text-align:left;
}
.title__link{ color:var(--text); text-decoration:none; }
.title__link:hover{ text-decoration:underline; }
.title__icon{ font-size:14px; color:#9ca3af; }

/* 상태 뱃지 */
.status-badge{
  min-width:120px; height:40px; padding:0 14px;
  border-radius:999px; font-weight:700; font-size:14px; border:0;
}
.status-badge.is-open{ background:#2152ff; color:#fff; }
.status-badge.is-closed{ background:#ebeef2; color:#9aa3ad; }

/* 더보기 */
.program-table__more{
  display:flex; justify-content:flex-end; align-items:center;
  margin:0 0 .5rem;
}
.btn-more{
  font-weight:600; background:transparent; border:none; cursor:pointer;
  transition: color .2s ease;
}
.btn-more:hover{ color:#0f1270; text-decoration:underline; }

/* =========================================================
   Features (카드형 리스트)
========================================================= */
.feature-list-title{
  font-size:1.625rem; font-weight:700; color:#001b3b; margin:18px 0 10px;
}
.feature-list{
  list-style:disc; margin:0 0 0 20px;
}
.feature-list li{ margin-bottom:6px; }

.feature-grid{
  list-style:none; margin:16px 0 0; padding:0;
  display:grid; grid-template-columns: repeat(2, minmax(0, 1fr));
  gap:16px;
}
.feature-card{
  display:grid; grid-template-columns:48px 1fr; align-items:start; gap:12px;
  padding:16px 14px;
  border:1px solid #e6ebf0; border-radius:10px; background:#fff;
  box-shadow: var(--card-shadow);
}
.feature-icon{
  width:48px; height:48px; border-radius:50%;
  display:inline-flex; align-items:center; justify-content:center;
  background:#f1f5ff; border:1px solid #dbe3ff;
}
.feature-icon i{ font-size:20px; color:var(--accent); }
.feature-body strong{
  display:block; font-weight:700; font-size:17px; color:var(--text); margin-bottom:4px;
}
.feature-body p{ margin:0; color:#454f5e; }

/* =========================================================
   Media List (카드형 미디어)
========================================================= */
.feat-media{
  list-style:none; margin:16px 0 30px; padding:0; display:grid; gap:12px;
}
.feat-media li{
  display:grid; grid-template-columns:36px 1fr; gap:16px; align-items:center;
  padding:18px 20px;
  border:1px solid rgba(48,48,138,.15);
  border-radius:16px; background:#fff;
  box-shadow: 0 4px 10px rgba(0,0,0,.04);
  transition: all .3s ease;
}
.feat-media li:hover{
  border-color:var(--accent);
  box-shadow: 0 6px 16px rgba(48,48,138,.12);
  transform: translateY(-2px);
  background:#f9faff;
}
.feat-media i{
  font-size:22px; width:56px; height:56px; border-radius:50%;
  display:flex; align-items:center; justify-content:center;
  background:#f1f5ff; color:var(--accent); border:1px solid #dbe3ff;
}
.feat-media strong{
  display:block; font-size:18px; font-weight:700; color:var(--text); margin-bottom:4px;
}
.feat-media p{
  margin:0; font-size:15px; line-height:1.6; color:#555;
}

/* =========================================================
   Responsive
========================================================= */

/* 태블릿 */
@media (max-width: 1024px){
  /* Program Table 칼럼 축소 */
  .program-table__head,
  .program-row{
    grid-template-columns: 70px 1fr 220px 160px 120px;
  }

  /* Portfolio: 배너 폭 줄이기 */
  .portfolio-content{
    grid-template-columns: 1fr 260px;
  }
}

/* 모바일 */
@media (max-width: 768px){
  /* Portfolio: 단일 컬럼 */
  .portfolio-content{
    grid-template-columns: 1fr;
  }
  .portfolio-banner{
    max-width:80%;
    margin: 0 auto;
    order:-1;               /* 필요하면 배너를 위로 */
  }

  /* Program Table: 모바일 카드형 */
  .program-table__head{ display:none; }
  .program-row{
    grid-template-columns: 120px;
    grid-template-areas:
      "title status"
      "period period"
      "deadline deadline"
      "no no";
    gap:8px 12px;
  }
  .td--title{ grid-area:title; }
  .td--status{ grid-area:status; justify-self:end; }
  .td--period{ 
    display: none;
    /* grid-area:period; color:#374151; text-align:left;  */
  }
  .td--deadline{ 
    display: none;

    /* grid-area:deadline; color:#374151; text-align:left; */
   }
  .td--no{ 
    display: none;

    /* grid-area:no; color:#6b7280; text-align:left;  */
  }
  .td--count{
    display: none;
  }

  /* Feature */
  .feature-grid{ grid-template-columns: 1fr; }
  .feature-card{
    grid-template-columns:40px 1fr;
    padding:14px 12px;
  }
  .feature-icon{ width:40px; height:40px; }
  .feature-icon i{ font-size:18px; }
}

/* 작은 모바일 */
@media (max-width: 600px){
  .feat-media li{
    grid-template-columns:40px 1fr; gap:10px;
  }
  .feat-media i{
    width:40px; height:40px; font-size:18px;
  }
}

</style>
